/**
 * mSTEM EXT-03 LED 8×8 designer modal container — thin redux wrapper
 * (Phase 6 / 06-04). The 8×8 boolean grid lives in LOCAL component state
 * (per RESEARCH Pattern 3); Redux only carries the modal open/close flag.
 *
 * Wires:
 *   - onRequestClose → closeLedDesigner() (modal flag)
 *   - dispatch (raw) → so the component can fire the extLedCopied toast via
 *     showAlertWithTimeout(dispatch, 'extLedCopied') after a successful copy.
 */
import {compose} from 'redux';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import {closeLedDesigner} from '../reducers/modals';

import LedMatrixDesignerModalComponent from '../components/led-matrix-designer-modal/led-matrix-designer-modal.jsx';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    dispatch,
    onRequestClose: () => dispatch(closeLedDesigner())
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(LedMatrixDesignerModalComponent);
